import { useQuery } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';
import { getRouteApi } from '@mint/routing';

const routerApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

export const usePreviewActivityListApi = () => {
  const { campaignId: planId } = routerApi.useParams();

  const { data, ...rest } = useQuery({
    ...MediaPlan.getPreviewActivityListQueryOptions({
      params: {
        mediaPlanId: planId,
      },
    }),
    staleTime: Infinity,
  });

  return { data: data?.data, ...rest };
};
